module.exports = __webpack_public_path__ + "img/27.c39f7de6.png";